import Vue from 'vue';
import RemindToast from '@/components/appointment/RemindToast.vue';

export function showReminderToast(data, onRemindCallback) {
  // Tạo instance component
  const ToastConstructor = Vue.extend(RemindToast);
  const instance = new ToastConstructor({
    propsData: { data, onRemind: onRemindCallback }
  });

  // Lắng nghe sự kiện 'remind'
  instance.$on('remind', () => {
    if (onRemindCallback) onRemindCallback();
    instance.$destroy();
    document.body.removeChild(instance.$el);
  });

  // Mount vào DOM
  instance.$mount();
  document.body.appendChild(instance.$el);
}
